import { Component } from '@angular/core';
import { translation } from '@cue/translations';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'addin-reservation-cannot-fetch',
  templateUrl: './reservation-cannot-fetch.component.html',
  styleUrls: ['./reservation-cannot-fetch.component.scss'],
  imports: [TranslocoPipe],
})
export class ReservationCannotFetchComponent {
  translation = translation;
}
